import { memo } from "react";
import { TouchBackend } from 'react-dnd-touch-backend'
import { DndProvider } from 'react-dnd'
import Container from "./ContainerDragDrop";

// TouchBackend (mouse+touch via JS) em vez de HTML5Backend: o drag nativo do HTML5
// depende do navegador iniciar o gesto de arraste no SO, o que é instável no Chrome
// (trava sem erro, sem feedback visual) mesmo com draggable=true e CSS corretos.
const touchBackendOptions = { enableMouseEvents: true };

export default function Painel({style, width = 14, height = 14, boxes, setBoxes, editable = false}) {

    return(
        <div style={style}>
            <DndProvider backend={TouchBackend} options={touchBackendOptions}>
                <Container height={height} width={width} boxes={boxes} setBoxes={setBoxes} editable={editable}/>
            </DndProvider>
        </div>
    );

};
